import {Component, Input} from '@angular/core';
import {ModalsService} from "../../services/modals.service";
import {RulesService} from "../../services/rules.service";
import {Group} from "../../model/group";

@Component({
  selector: 'app-delete-group-modal',
  templateUrl: './delete-group-modal.component.html',
  styleUrls: ['./delete-group-modal.component.css']
})
export class DeleteGroupModalComponent {
  @Input() group: Group;

  requestInProgress: boolean;
  removed: boolean;

  constructor(private readonly modalsService: ModalsService,
              private readonly rulesService: RulesService) {
    this.requestInProgress = false;
    this.removed = false;
  }

  close(): void {
    this.modalsService.hideModal();
  }

  delete(): void {
    if (!this.requestInProgress) {
      this.requestInProgress = true;
      this.rulesService.deleteGroup(this.group.id)
        .subscribe(code => {
          if (code == 200) {
            this.removed = true;
          }
          this.rulesService.loadContacts();
          this.rulesService.loadGroups();
          this.requestInProgress = false;
        });
    }
  }
}
